/**
 * @generated SignedSource<<48e55e43da8199af04893d5b1d290b83>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CompletionStrategy = "ADD_TO_SHOPIFY_CART" | "ASK_DESIGN_COPY_BY_EMAIL" | "CREATE_SHOPIFY_DRAFT_ORDER";
export type StandaloneSiteAccessMode = "IAM_ONLY" | "PASSWORD" | "PUBLIC";
export type StandaloneSiteStatus = "ACTIVE" | "DISABLED" | "DRAFT";
export type StandaloneSiteUpdateInput = {
  accessMode?: StandaloneSiteAccessMode | null;
  completionStrategy?: CompletionStrategy | null;
  description?: string | null;
  domain?: string | null;
  id: string;
  name?: string | null;
  password?: string | null;
  shopifyHeadlessStorefrontToken?: string | null;
  status?: StandaloneSiteStatus | null;
};
export type salesChannelRenameMiniSiteMutation$variables = {
  input: StandaloneSiteUpdateInput;
};
export type salesChannelRenameMiniSiteMutation$data = {
  readonly updateStandaloneSite: {
    readonly id: string;
    readonly name: string;
  };
};
export type salesChannelRenameMiniSiteMutation = {
  response: salesChannelRenameMiniSiteMutation$data;
  variables: salesChannelRenameMiniSiteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "StandaloneSiteInfo",
    "kind": "LinkedField",
    "name": "updateStandaloneSite",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "salesChannelRenameMiniSiteMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "salesChannelRenameMiniSiteMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "8c9c758d25497e9e7f1633e9d411b39b",
    "id": null,
    "metadata": {},
    "name": "salesChannelRenameMiniSiteMutation",
    "operationKind": "mutation",
    "text": "mutation salesChannelRenameMiniSiteMutation(\n  $input: StandaloneSiteUpdateInput!\n) {\n  updateStandaloneSite(input: $input) {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "a0beffce34687601355357414aa9e6b9";

export default node;
